import React from "react";
import $ from "jquery";
import PreviewerIFrameStudio from "../../components/PreviewerIFrame/PreviewerIFrameStudio";
import { isVideoPlaying } from "../../util/creativeUtil";

interface StudioPreviewerProps {
  buildID: string;
  prebuiltAdElement: HTMLElement | null;
  creativeFormat: string;
  sessionSize: number;
  attentionTime: number;
  scriptVersion: string;
  creativeNames: string[];
  brandNames: string[];
  campaignNames: string[];
  containsVideo: boolean;
  setCreativeScrollProgress: (progress: number) => void;
  setIframeVideo: (videoElement: HTMLVideoElement | null) => void;
  setIframeVideoProgress: (progress: number) => void;
}

const StudioPreviewer: React.FC<StudioPreviewerProps> = ({
  buildID,
  prebuiltAdElement,
  creativeFormat,
  sessionSize,
  attentionTime,
  scriptVersion,
  creativeNames,
  brandNames,
  campaignNames,
  containsVideo,
  setCreativeScrollProgress,
  setIframeVideo,
  setIframeVideoProgress,
}) => {
  const iframeScrollHandlerStudio = (e: any, targetFrame: any) => {
    if (!targetFrame) return;

    const containerViewportHeight = e.currentTarget.innerHeight;
    const targetFrameRect = targetFrame.getBoundingClientRect();
    const targetFrameHeight = targetFrameRect.height;
    const totalScrollDistance = containerViewportHeight + targetFrameHeight;
    const traveledDistance = containerViewportHeight - targetFrameRect.top;
    let progress = (traveledDistance / totalScrollDistance) * 100;
    const clamp = (num: number, min: number, max: number) =>
      Math.min(Math.max(num, min), max);
    progress = clamp(progress, 0, 100);
    setCreativeScrollProgress(progress);
  };

  const iframeOnLoadHandlerStudio = async (e: any) => {
    let phoneWrapperDiv = e.target;
    const rendererIframe = phoneWrapperDiv.querySelector("iframe");

    if (!rendererIframe) return;

    // Ensure the iframe has rounded corners to match the device frame
    rendererIframe.style.borderRadius = "0 0 36px 36px";

    rendererIframe.addEventListener("load", async () => {
      const iframeWindow = rendererIframe.contentWindow;
      let targetFrame = iframeWindow.document.querySelector("#ad iframe");

      let foundVideo = false;

      /**
       * Check for the video element in the hangtime-overlay iframe
       * and set the iframeVideo and iframeVideoProgress
       */
      const checkVideoElement = () => {
        if (containsVideo && !foundVideo) {
          const hangtimeOverlayIframe = iframeWindow.document.querySelector(
            ".hangtime-overlay iframe"
          );
          if (!hangtimeOverlayIframe) {
            console.warn("Could not find hangtime-overlay iframe");
            return;
          }

          const videoElement: HTMLVideoElement | undefined =
            hangtimeOverlayIframe.contentWindow.document.querySelector(
              "video[tracking-enabled]"
            );
          if (!videoElement) {
            console.warn("Could not find tracking-enabled video element");
            return;
          }

          foundVideo = true;
          setIframeVideo(videoElement);

          let videoWatcher = setInterval(() => {
            if (isVideoPlaying(videoElement)) {
              setIframeVideoProgress(
                (videoElement.currentTime / videoElement.duration) * 100
              );
            }
          }, 25);

          targetFrame.addEventListener("beforeunload", function () {
            clearInterval(videoWatcher);
          });
        }
      };

      iframeWindow.addEventListener("scroll", (ev: any) => {
        iframeScrollHandlerStudio(ev, targetFrame);
        checkVideoElement();
      });

      const $target = $(rendererIframe);
      $target.contents().children().scrollTop(800);
      let scrollDistance = 1450;
      $target.contents().children().animate(
        {
          scrollTop: scrollDistance,
        },
        1500,
        "swing"
      );

      /**
       * Defers the video element search until the tab is visible. It might be hidden if the tab is not active or the user has switched to another window or app
       * It polls for the element for up to 5 seconds once the tab is active.
       */
      if (containsVideo && !foundVideo && document.hidden) {
        const visibilityHandler = () => {
          if (!document.hidden) {
            checkVideoElement();
            let videoCheckCounter = 0;
            const checkVideoTimer = setInterval(() => {
              checkVideoElement();

              if (foundVideo) {
                document.removeEventListener(
                  "visibilitychange",
                  visibilityHandler
                );
                clearInterval(checkVideoTimer);
              }
              if (videoCheckCounter > 20) {
                document.removeEventListener(
                  "visibilitychange",
                  visibilityHandler
                );
                clearInterval(checkVideoTimer);
              }
              videoCheckCounter++;
            }, 250);
          }
        };

        document.addEventListener("visibilitychange", visibilityHandler);
      }
    });
  };

  return (
    <PreviewerIFrameStudio
      elementHtml={prebuiltAdElement?.outerHTML}
      creativeFormat={creativeFormat}
      onLoadHandler={iframeOnLoadHandlerStudio}
      creativeID={buildID}
      sessionSize={sessionSize}
      attentionTime={attentionTime}
      scriptVersion={scriptVersion}
      creativeNames={creativeNames}
      brandNames={brandNames}
      campaignNames={campaignNames}
      isLoading={false}
      isLegacy={true}
    />
  );
};

export default StudioPreviewer;
